import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserProfile } from '../user/user.datamodel';
import { UserService } from '../user/user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  user!: UserProfile;

  constructor(
    private readonly userService: UserService
  ) {
  }

  canActivate(_route?: ActivatedRouteSnapshot, state?: RouterStateSnapshot): boolean {
    if (state && state.url.startsWith('/login')) {
      return !this.isLoggedUser();
    }

    return this.isLoggedUser();
  }

  private isLoggedUser(): boolean {
    if (!this.user || !this.user.userId) {
      this.user = this.userService.getUser();
    }
    return !!this.user?.userId;
  }
}
